module.exports = __webpack_public_path__ + "static/media/DSCF0016.92f5378c.jpg";